import { QuestionLoadingProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { InputFieldset } from '@/components/fhirEngineClinical/inputFieldset'

export function QuestionLoading({
  label,
  required,
  helperText
}: QuestionLoadingProps) {
  return (
    <InputFieldset label={label} required={required} helperText={helperText}>
      <div className='text-muted-foreground my-3 flex items-center justify-center gap-2 text-sm'>
        <HugeiconsIcon
          icon={Loading03Icon}
          strokeWidth={2}
          className='size-4 animate-spin'
        />
        loading question
      </div>
    </InputFieldset>
  )
}
